"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_CapabilityStatement_Document = exports.CapabilityStatement_DocumentModeKind = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_markdown_1 = require("../Scalar/RTTI_markdown");
var RTTI_canonical_1 = require("../Scalar/RTTI_canonical");
var CapabilityStatement_DocumentModeKind;
(function (CapabilityStatement_DocumentModeKind) {
    CapabilityStatement_DocumentModeKind["_producer"] = "producer";
    CapabilityStatement_DocumentModeKind["_consumer"] = "consumer";
})(CapabilityStatement_DocumentModeKind = exports.CapabilityStatement_DocumentModeKind || (exports.CapabilityStatement_DocumentModeKind = {}));
var EnumType_1 = require("../../EnumType");
exports.RTTI_CapabilityStatement_Document = t.recursion('ICapabilityStatement_Document', function () {
    return t.intersection([
        t.type({
            profile: RTTI_canonical_1.RTTI_canonical
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            mode: (0, EnumType_1.createEnumType)(CapabilityStatement_DocumentModeKind, 'CapabilityStatement_DocumentModeKind'),
            _mode: RTTI_Element_1.RTTI_Element,
            documentation: RTTI_markdown_1.RTTI_markdown,
            _documentation: RTTI_Element_1.RTTI_Element
        })
    ]);
});
//# sourceMappingURL=RTTI_CapabilityStatement_Document.js.map